import { v4 as uuidv4 } from "uuid";
import { makeAutoObservable, reaction } from "mobx";

class Question {
  constructor(
    id = uuidv4(),
    question = "",
    type = "",
    answer = "",
    order = 0,
    section = null
  ) {
    //Valorar si volem ficar que es puguin dividir per parts els questionaris (mirar com queda sense)
    this.id = id;
    this.question = question;
    this.type = type;
    this.answer = answer;
    this.order = order;
    this.section = section;
    makeAutoObservable(this);
  }

  updateUserQuestion(questionData) {
    this.question = questionData.question;
    this.order = questionData.order;
    this.type = questionData.type;
    this.answer = questionData.answer;
  }

  typeLocalized(t) {
    if (this.type === "Texto") {
      return t("questionTextType-string");
    } else {
      return t("questionNumberType-string");
    }
  }

  setProperty(propertyName, value) {
    if (Object.hasOwnProperty.call(this, propertyName)) {
      this[propertyName] = value;
    } else {
      console.error(`Property ${propertyName} does not exist.`);
    }
  }
  getProperty(propertyName) {
    if (Object.hasOwnProperty.call(this, propertyName)) {
      return this[propertyName];
    } else {
      console.error(`Property ${propertyName} does not exist.`);
      return undefined;
    }
  }
}
export default Question;
